import { Paginated } from "src/@types/paginated";
import { Tags } from "@/enum/tags";
import { apiSlice } from "../../http";
import { IQuery, IQueryParams } from "@/@types/query";

export const QueryInformations = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQuerys: builder.query<Paginated<IQuery>, IQueryParams>({
      query: ({ search, meta, orderBy, perPage }) => {
        const params = new URLSearchParams({
          search,
          orderBy,
          page: meta.page.toString(),
          perPage: perPage.toString(),
        });

        return {
          url: `/query-updates/querys?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.QUERY_UPDATE],
    }),
    getPersonalRequests: builder.query<Paginated<IQuery>, IQueryParams>({
      query: ({ search, meta, orderBy, perPage }) => {
        const params = new URLSearchParams({
          search,
          orderBy,
          page: meta.page.toString(),
          perPage: perPage.toString(),
        });

        return {
          url: `/query-updates/personal-querys/?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.QUERY_UPDATE],
    }),
    getOneQuery: builder.query<any, { id: string }>({
      query: ({ id }) => {
        return {
          url: `/query-updates/query/${id}`,
          method: "GET",
        };
      },
      providesTags: [Tags.QUERY_UPDATE],
    }),
    approveQuery: builder.mutation<any, { id: string; comment?: string }>({
      query: ({ id, comment }) => {
        return {
          url: `/query-updates/query/approve`,
          method: "POST",
          body: {
            id,
            comment,
          },
        };
      },
      invalidatesTags: [Tags.QUERY_UPDATE],
    }),
    reproveQuery: builder.mutation<any, { id: string; comment?: string }>({
      query: ({ id, comment }) => {
        return {
          url: `/query-updates/query/reprove`,
          method: "POST",
          body: {
            id,
            comment,
          },
        };
      },
      invalidatesTags: [Tags.QUERY_UPDATE],
    }),
    executeQuery: builder.mutation<
      any,
      { query: string; connectionId: number }
    >({
      query: ({ query, connectionId }) => {
        return {
          url: `/query-updates/query`,
          method: "POST",
          body: { query, connectionId },
        };
      },
      invalidatesTags: [Tags.QUERY_UPDATE],
    }),
    executeQueryPreview: builder.mutation<
      any,
      { query: string; connectionId: number }
    >({
      query: ({ query, connectionId }) => {
        return {
          url: `/query-updates/query-preview`,
          method: "POST",
          body: { query, connectionId },
        };
      },
      invalidatesTags: [Tags.QUERY_UPDATE],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetQuerysQuery,
  useGetOneQueryQuery,
  useGetPersonalRequestsQuery,
  // useUpdateFavoriteMutation,
  useApproveQueryMutation,
  useReproveQueryMutation,
  useExecuteQueryMutation,
  useExecuteQueryPreviewMutation,
} = QueryInformations;
